'use client'

import SignupTracker from '@/components/SignupTracker'
import { getCookie } from 'cookies-next'
import { Sku } from '@/types/interfaces/sku'
import { useEffect, useRef } from 'react'
import { trackStoreEvent, StoreAnalytics, PageLocation } from '@nile/mantine-theme/analytics'

export default function SkuDetailPageClient({ sku }: { sku: Sku }) {
    // This cookie will be set when the user first visits a SKU detail page while unauthed.
    // If it is not set, then this is almost certainly an existing customer and there's no need
    // to send "signup complete" analytics events.
    const skuId = getCookie('sku_id', {}) || ''
    // Track which SKU we've already sent analytics for to prevent duplicates on each render 
    const trackedSkus = useRef<Set<string>>(new Set())

    // Track SKU detail page view on component mount
    useEffect(() => {
        if (sku?.id && !trackedSkus.current.has(sku.id)) {
            trackStoreEvent(StoreAnalytics.VIEWED_DETAIL_PAGE, {
                location: PageLocation.DETAIL_PAGE,
                sku_id: sku.id,
                sku_name: sku.name,
            })
            trackedSkus.current.add(sku.id)
        }
    }, [sku?.id])

    return <>{skuId && <SignupTracker />}</>
}
